import React, {Component} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-light-svg-icons/faTimes";
import ReactTooltip from "react-tooltip";

class TooltipClose extends Component {

    handleCloseClick(e) {
        this.props.tooltip.current.tooltipRef = null;
        ReactTooltip.hide();
    }

    render() {
        return (
            <div
                key="tooltip-close-button"
                className={"tooltip__close"}
                onClick={this.handleCloseClick.bind(this)}
            >
                <FontAwesomeIcon icon={faTimes}/>
            </div>
        );
    }
}

export default TooltipClose;


/** WEBPACK FOOTER **
 ** ./src/components/TooltipClose.js
 **/